// The privacy notice a person accepts before reading or sending messages.
//
// THE WORDS ARE THE APP'S, copied from apps/mobile/src/components/social/
// DmDisclosureSheet.tsx. The two must stay the same: the server keeps one acceptance
// per person, per project and per version, so accepting on the phone counts here and
// accepting here counts on the phone. A person must have been shown the same thing in
// both places. Change the words in both files together, and only together with the
// server's version number (SOCIAL_DM_DISCLOSURE_VERSION in apps/api/src/services/
// social-dm.service.ts).
//
// NOTICE_VERSION is the version these words are. The server says which version it
// wants accepted. If that is ever a different one, the page does not offer to accept:
// the server would record that the person saw words this page never showed them.
export const NOTICE_VERSION = 2;

export const NOTICE_TITLE = 'Before you start messaging';

/** One entry per paragraph, in the app's order. */
export const NOTICE_PARAGRAPHS: readonly string[] = [
  'Direct messages here are a work tool, not a private channel.',
  'An administrator at your company can open any conversation, including this one. They can read what you write, see the photos you send, and listen to the voice messages you record. All of it is kept as a record.',
  'If something you receive is inappropriate, you can report it from the conversation — reports go to the moderation team, who can see and hear the same things.',
];

/** The one button, worded as the app's. */
export const NOTICE_ACCEPT = 'I understand';
